import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchCoreChipDisplayComponent } from './search-core-chip-display.component';
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule} from "ngx-bootstrap/popover";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';



@NgModule({
  declarations: [SearchCoreChipDisplayComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    FormsModule,
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
  ],
  exports: [SearchCoreChipDisplayComponent]
})
export class SearchCoreChipDisplayModule { }
